import script from "./DeleteConfirmDialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./DeleteConfirmDialog.vue?vue&type=script&lang=ts&setup=true"

import "./DeleteConfirmDialog.vue?vue&type=style&index=0&id=101613da&scoped=true&lang=css"

import exportComponent from "D:\\x1\\vue3-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-101613da"]])

export default __exports__